import React, { FC } from 'react';
import { batch } from 'react-redux';
import Modal from './common/Modal/Modal';
import { setModal, selectModalSlice } from '../redux/slices/modalSlice';
import { useAppSelector, useAppDispatch } from '../hooks';
import {
  setSelectedToChain,
  setSelectedFromChain,
} from '../redux/slices/bridgeSlice';
import { setToChainWalletProvider } from '../redux/slices/walletSlice';

const NetworkAlert: FC = () => {
  const dispatch = useAppDispatch();

  const { modalShowing } = useAppSelector(selectModalSlice);
  const agreementConfirm = React.useCallback(() => {
    batch(() => {
      dispatch(setSelectedFromChain(null));
      dispatch(setSelectedToChain(null));
      dispatch(setToChainWalletProvider(null));
      dispatch(setModal(`Hidden`));
    });

    dispatch(setModal(`Hidden`));
  }, [dispatch]);

  const onModalClose = React.useCallback(() => {
    batch(() => {
      dispatch(setSelectedFromChain(null));
      dispatch(setSelectedToChain(null));
    });
  }, [dispatch]);

  return (
    <Modal
      size="sm"
      isShow={modalShowing === `NetworkAlert`}
      title="Network Error"
      onClose={onModalClose}
      explanation={
        <>
          K STADIUM Bridge is only available on the Ethereum mainnet.
          <br />
          Please change the network in Metamask.
        </>
      }
      footerComponent={
        <button
          onClick={agreementConfirm}
          className="btn btn-block btn-primary btn-lg"
        >
          OK
        </button>
      }
    />
  );
};

export default NetworkAlert;
